import { FormButton } from "components/forms/part/FormButton/FormButton";
import { FormCheckbox } from "components/forms/part/FormCheckbox/FormCheckbox";
import { FormFreeText } from "components/forms/part/FormFreeText/FormFreeText";
import { FormLabel } from "components/forms/part/FormLabel/FormLabel";
import { FormSelect } from "components/forms/part/FormSelect/FormSelect";
import { FormText } from "components/forms/part/FormText/FormText";
import { FormTextArea } from "components/forms/part/FormTextArea/FormTextArea";
import { FormProps } from "components/forms/types";
import { Component, createRef } from "react";
import "./FormComponents.css";

class AppForm extends Component<FormProps> {
	private formRef = createRef<HTMLFormElement>();

	render():JSX.Element{
		const formClasses:string[] = ["rt-form", this.props.fieldDirection];

		if(this.props.justifyFields){
			formClasses.push(this.props.justifyFields);
		}

		return (
			<form className={formClasses.join(" ")} onSubmit={(e) => { e.preventDefault(); }} ref={this.formRef}>
				{this.props.children}
			</form>
		);
	}

	componentDidMount = ():void => {
		if(this.props.fieldDirection === "column"){
			this.setLabelWidth();
		}

		if(!this.formRef.current){ return; }

		const editButtons = this.formRef.current.querySelectorAll<HTMLDivElement>(".field-edit");
		if(!editButtons){ return; }

		editButtons.forEach((btn:HTMLDivElement) => {

			// Remove the listeners first to prevent them from being added multiple times
			btn.removeEventListener("click", this.editButtonClick);
			btn.addEventListener("click", this.editButtonClick);
		});
	}

	setLabelWidth = ():void => {
		const wrapper = this.formRef.current as HTMLFormElement;
		if(!wrapper){ return; }
		const labels = wrapper.getElementsByClassName("field-label");
		let maxWidth = 0;
		const labelsArr = Array.from(labels) as HTMLLabelElement[];
		labelsArr.forEach((label) => { maxWidth = label.offsetWidth > maxWidth ? label.offsetWidth : maxWidth; });
		labelsArr.forEach((label) => { label.style.width = `${maxWidth}px`; });
	}

	editButtonClick = (evt:MouseEvent):void => {
		const ele = evt.currentTarget as HTMLDivElement;
		const input = ele.previousSibling as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
		if(!input){ return; }

		input.disabled = false;
	}
}

const FormComponents = {
	Form: AppForm,
	Button: FormButton,
	Label: FormLabel,
	Select: FormSelect,
	TextArea: FormTextArea,
	TextInput: FormText,
	Checkbox: FormCheckbox,
	FreeText: FormFreeText,
};
Object.freeze(FormComponents);
export default FormComponents;
